import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 11 8\" id=\"check\">\n    <path fill-rule=\"nonzero\" d=\"M9.778 0L4.48 5.474 1.222 2.105 0 3.37 4.481 8 11 1.263z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol